<template>
  <div v-if="loading" class="loader">
    <svg :width="width" :height="height" viewBox="0 0 100 100" class="circular">
      <circle
        class="path"
        cx="50"
        cy="50"
        r="20"
        fill="none"
        stroke-width="4"
        stroke-miterlimit="10"
      />
    </svg>
  </div>
</template>
<script>
/*
 *
 * Github: https://gist.github.com/richstandbrook/e2c38d3c61070a5b5c30
 * Demo: https://codepen.io/anon/pen/dPWVbQ
 *
 */
export default {
  name: 'Loader',
  components: {},
  directives: {},
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>
<style lang="scss">
@keyframes rotate {
  100% {
    transform-origin: center;
    transform: rotate(360deg);
  }
}
@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124;
  }
}
.loader {
  position: relative;
  display: inline-block;
  margin: 0px auto;
  zoom: 1;
  .circular {
    animation: rotate 1s linear infinite;
    position: relative;
    // width: 100px; // use props
    // height: 100px; // use props
  }
  .path {
    stroke: #f4b93b;
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    animation: dash 1.5s ease-in-out infinite;
    stroke-linecap: round;
  }
}
</style>
